import { error, get } from 'jquery'
import React from 'react'
import { API } from 'utils/Apiroutes'
import Useaxios from 'utils/Useaxios'

const productService = () => {
    const { fetchData } = Useaxios()

    const getCategory = async () => {
        try {
            const res = await fetchData({
                url: API.getCategory,
                method: "GET",
                showMessage: false,
                params: {
                    limit: 10000
                }
            })
            console.log(res)
            return res
        } catch (error) {
            return error

        }
    }

    const getProducts = async (params = {}) => {
        try {
            const res = await fetchData({
                url: API.getProduct,
                method: "GET",
                showMessage: false,
                params: { limit: 10000, ...params }

            })
            return res
        } catch (error) {
            return error
        }
    }

    const getProductDataWithDetails = async (id) => {
        try {
            const res = await fetchData({
                url: API.getProductWithDetails(id),
                method: "GET",
            })
            return res
        } catch (error) {
            return error
        }
    }
    return {
        getCategory,
        getProducts,
        getProductDataWithDetails
    }
}

export default productService
